import { Avatar } from '@material-ui/core';
import styled from "styled-components";

const StyledAvatar = styled(Avatar)`
  cursor: pointer;
`;

export default StyledAvatar;
